import lazyWithPreload from "../../app/components/lazyWithPreload";

const LoadableClassroom = lazyWithPreload(
  () => import(/* webpackChunkName: "classroom-chunk" */ "./classroom/Route")
);

export default LoadableClassroom;
